import React from 'react';
import Image from 'next/image';
import { useTranslation } from 'next-i18next';

const SchoolOverviewClasses = () => {
  const { t } = useTranslation('common');
  return (
    <div className="school-section">
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-12 lg:col-span-7 md:col-span-6">
          <h2 className="school-section-title h3">
            {t('service.school.overview.explanations.title.effectiveClasses')}
          </h2>
          <p className="school-section-description">
            {t('service.school.overview.explanations.detail.effectiveClasses')}
          </p>
        </div>
        <div className="order-first md:order-last col-span-12 lg:col-span-5 md:col-span-6">
          <Image
            alt="LingualBox Class"
            width={358}
            height={266}
            src="/images/class.png"
          />
        </div>
      </div>
    </div>
  );
};

export default SchoolOverviewClasses;
